"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScalarObservable = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Observable2 = require("../Observable");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable =
/*#__PURE__*/
function (_Observable) {
  (0, _inherits2.default)(ScalarObservable, _Observable);

  function ScalarObservable(value, scheduler) {
    var _this;

    (0, _classCallCheck2.default)(this, ScalarObservable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ScalarObservable).call(this));
    _this.value = value;
    _this.scheduler = scheduler;
    _this._isScalar = true;

    if (scheduler) {
      _this._isScalar = false;
    }

    return _this;
  }

  (0, _createClass2.default)(ScalarObservable, [{
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      var value = this.value;
      var scheduler = this.scheduler;

      if (scheduler) {
        return scheduler.schedule(ScalarObservable.dispatch, 0, {
          done: false,
          value: value,
          subscriber: subscriber
        });
      } else {
        subscriber.next(value);

        if (!subscriber.closed) {
          subscriber.complete();
        }
      }
    }
  }], [{
    key: "create",
    value: function create(value, scheduler) {
      return new ScalarObservable(value, scheduler);
    }
  }, {
    key: "dispatch",
    value: function dispatch(state) {
      var done = state.done,
          value = state.value,
          subscriber = state.subscriber;

      if (done) {
        subscriber.complete();
        return;
      }

      subscriber.next(value);

      if (subscriber.closed) {
        return;
      }

      state.done = true;
      this.schedule(state);
    }
  }]);
  return ScalarObservable;
}(_Observable2.Observable);

exports.ScalarObservable = ScalarObservable;